<script lang="ts">
  import moneyFormatters from "@shared/filters/money.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let containerDeposit: number;
  export let containerType: string;
  export let containerCount: number;
  export let includedInPrice = false;

  const isEligibleForDeposit = ["keg", "bottle", "can"].includes(containerType);

  const containerDepositPerUnit = () => {
    return containerDeposit / containerCount;
  };

  const pricingString = includedInPrice ? "included in price" : "applied on final invoice";

  $: formattedTotalContainerDeposit = moneyFormatters
    .filter()(containerDeposit)
    .replace(/\.00$/, "");
  $: formattedContainerDeposit = moneyFormatters
    .filter()(containerDepositPerUnit())
    .replace(/\.00$/, "");

</script>

{#if containerDeposit && isEligibleForDeposit}
  <div class="fizz-flex-row-4 fizz-align-content-start container-deposit-string">
    <Icon type="CreditsColor" fill="#000" height="20" width="12" />
    <p>
      {formattedTotalContainerDeposit}
      {containerType} deposit {pricingString} ({formattedContainerDeposit}/{containerType})
    </p>
  </div>
{/if}
